import { render, staticRenderFns } from "./ProduceToBeSold.vue?vue&type=template&id=34959a3e&scoped=true&"
import script from "./ProduceToBeSold.vue?vue&type=script&lang=js&"
export * from "./ProduceToBeSold.vue?vue&type=script&lang=js&"
import style0 from "./ProduceToBeSold.vue?vue&type=style&index=0&id=34959a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34959a3e",
  null
  
)

export default component.exports